module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới chặn tuyến đường",
      "breadcrumbs": [{
        title: 'Quản lý chặn tuyến đường',
        route: {
          name: 'blocks'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all padding-lg-bottom"
  }, [_c('el-form', {
    ref: "create-block-form",
    staticClass: "margin-top",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localBlock,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Chọn bảng giá"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "Nhập tên bảng giá",
      "remote-method": _vm.selectPriceTable,
      "loading": _vm.fetchPriceTable
    },
    on: {
      "change": _vm.selectSuggettionPriceTable
    },
    model: {
      value: (_vm.suggettionPriceTable),
      callback: function($$v) {
        _vm.suggettionPriceTable = $$v
      },
      expression: "suggettionPriceTable"
    }
  }, _vm._l((_vm.listPriceTable), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item
      }
    }, [_c('span', {
      staticClass: "pull-left text-gray"
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" " + _vm._s(item.name))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Chọn tỉnh thành"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "disabled": !_vm.localBlock.price_table_id,
      "filterable": "",
      "placeholder": "Chọn tỉnh thành"
    },
    on: {
      "change": _vm.getDistricts
    },
    model: {
      value: (_vm.localBlock.city_id),
      callback: function($$v) {
        _vm.$set(_vm.localBlock, "city_id", $$v)
      },
      expression: "localBlock.city_id"
    }
  }, _vm._l((_vm.blockCities), function(city, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Chọn quận huyện"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "disabled": !_vm.localBlock.city_id,
      "filterable": "",
      "placeholder": "Chọn quận huyện"
    },
    on: {
      "change": _vm.generateData
    },
    model: {
      value: (_vm.localBlock.district_id),
      callback: function($$v) {
        _vm.$set(_vm.localBlock, "district_id", $$v)
      },
      expression: "localBlock.district_id"
    }
  }, _vm._l((_vm.districts), function(district, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": district.name,
        "value": district.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.localBlock.price_table_id) ? _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "padding-all",
    attrs: {
      "span": 8
    }
  }, [_c('h3', [_vm._v("Thông tin bảng giá: ")]), _vm._v(" "), _c('p', [_vm._v("Tên bảng giá: " + _vm._s(_vm.priceTable.name))]), _vm._v(" "), _c('p', [_vm._v("Hãng vận chuyển: " + _vm._s(_vm.priceTable.carrier.data.name) + " ")]), _vm._v(" "), _c('p', [_vm._v("Dịch vụ: " + _vm._s(_vm.priceTable.service.data.name) + " ")]), _vm._v(" "), _c('p', [_vm._v("Thành phố đi: " + _vm._s(_vm.priceTable.city_from.data.name) + " ")]), _vm._v(" "), _c('p', [_vm._v("Vùng miền đến: " + _vm._s(_vm.priceTable.region_to.data.name) + " ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('h3', [_vm._v("\n          Thông chặn tuyến đường\n          "), _c('button', {
    staticClass: "ui blue basic mini button pull-right",
    attrs: {
      "disabled": !_vm.localBlock.city_id,
      "type": "button"
    },
    on: {
      "click": _vm.validatorBeforeSubmit
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": [{}],
      "show-header": false,
      "row-class-name": "row-like-header"
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              Chọn/bỏ chọn tất cả\n            ")]
      }
    }], null, false, 2302584087)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chiều đi",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          attrs: {
            "indeterminate": _vm.isIndeterminateFrom
          },
          on: {
            "change": _vm.handleCheckAllFrom
          },
          model: {
            value: (_vm.checkAllFrom),
            callback: function($$v) {
              _vm.checkAllFrom = $$v
            },
            expression: "checkAllFrom"
          }
        })], 1)]
      }
    }], null, false, 3880839541)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chiều đến",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          attrs: {
            "indeterminate": _vm.isIndeterminateTo
          },
          on: {
            "change": _vm.handleCheckAllTo
          },
          model: {
            value: (_vm.checkAllTo),
            callback: function($$v) {
              _vm.checkAllTo = $$v
            },
            expression: "checkAllTo"
          }
        })], 1)]
      }
    }], null, false, 3278353720)
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataBlocks,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Điểm giao/ lấy"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.district) + "\n            ")]
      }
    }], null, false, 2750290875)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chiều đi",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          model: {
            value: (scope.row.from),
            callback: function($$v) {
              _vm.$set(scope.row, "from", $$v)
            },
            expression: "scope.row.from"
          }
        })], 1)]
      }
    }], null, false, 635770678)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Chiều đến",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('el-checkbox', {
          model: {
            value: (scope.row.to),
            callback: function($$v) {
              _vm.$set(scope.row, "to", $$v)
            },
            expression: "scope.row.to"
          }
        })], 1)]
      }
    }], null, false, 2491757531)
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic mini margin-top button pull-right",
    attrs: {
      "disabled": !_vm.localBlock.city_id,
      "type": "button"
    },
    on: {
      "click": _vm.validatorBeforeSubmit
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-21da5f51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/NewBlock.vue
// module id = 696
// module chunks = 1